// Logo-list Swiper
document.addEventListener('DOMContentLoaded', function () {
  const logoSwiper = new Swiper('.logo-slider-section .logo-slider', {
    slidesPerView: "auto",
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
    },
    a11y: true,
    // spaceBetween: 20,
    // breakpoints: {
    //   769: {
        // spaceBetween: 40,
    //   },
    // },
  });
});

// Footer Section(Newsletter input)
document.addEventListener("DOMContentLoaded", function () {
  const footerNewsletterInput = document.querySelector(".footer__block--newsletter input[name='contact[email]']");
  
  if (footerNewsletterInput) {
    footerNewsletterInput.placeholder = "Email address";
  }
});   

// Hero carousel Section Sliding Effect
document.addEventListener("DOMContentLoaded", function () {
  const heroCarousel = document.querySelectorAll('.js-hero-carousel')
  if (heroCarousel.length) {
    heroCarousel.forEach(function (el, index) {
      el.classList.add(`s${index}`);
      new Swiper(`.js-hero-carousel.s${index}`, {
        slidesPerView: 1,
        autoplay: (el.dataset.autoplay == 'true') ? { delay: el.dataset.speed, disableOnInteraction: false } : false,
        effect: "fade",
        a11y: false,
        // slideActiveClass: "swiper-slider-active-slide",
        fadeEffect: {
          crossFade: true
        },
        autoplayDisableOnInteraction: false,
        loop: true,
        pagination: {
          el: `.js-hero-carousel.s${index} .swiper-pagination`,
          clickable: true
        }
      })
    })
  } 
  
});


// --------------------------------------------| Bipinsingh JS Start |------------------------------------------------ // 
// Custom 2-3 col img text under Section Swiper JS 

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".swiper-custom-2-3-col-img-text-under", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: false,
    grabCursor: false,
    breakpoints: {
      390: {
        spaceBetween: 20,
      },
      768: {
        spaceBetween: 30,
      },
    },
  });
});


// ---------------------------------------------| Bipinsingh JS End |------------------------------------------------- //

//read more metafield text js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.toggle-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const targetId = button.getAttribute('data-toggle-target');
      const metaTextContent = document.getElementById(targetId);

      if (!metaTextContent) return;

      // Add toggle-content class if not present
      if (!metaTextContent.classList.contains('toggle-content')) {
        metaTextContent.classList.add('toggle-content');
        // Set initial max-height for animation
        if (metaTextContent.hasAttribute('hidden')) {
          metaTextContent.style.maxHeight = '0';
          metaTextContent.style.opacity = '0';
        } else {
          metaTextContent.style.maxHeight = metaTextContent.scrollHeight + 'px';
        }
      }

      const isHidden = metaTextContent.hasAttribute('hidden');
      if (isHidden) {
        // Open animation
        metaTextContent.removeAttribute('hidden');
        metaTextContent.style.maxHeight = metaTextContent.scrollHeight + 'px';
        metaTextContent.style.opacity = '1';
        button.textContent = 'Read Less';
      } else {
        // Close animation
        metaTextContent.style.maxHeight = '0';
        metaTextContent.style.opacity = '0';
        // Delay setting hidden attribute until animation completes
        setTimeout(() => {
          metaTextContent.setAttribute('hidden', '');
        }, 300); // Match transition duration (0.3s)
        button.textContent = 'Read More';
      }
    });
  });
});

